<template>
    <div
        v-if="!productPageStore.configurableProduct.is_hiding_shipping_options && hasShippingOptions"
        :class="[
            'rounded-md border border-border/40 bg-gray-100/50 p-4 md:mx-4 lg:mx-0',
            { 'animate-pulse': productPageStore.isRetrievingShippingOptions },
        ]"
    >
        <div class="flex items-center justify-between border-b border-b-gray-300/60 pb-3">
            <span class="text-xl font-semibold" v-text="$t('general.shipping_options.title')" />
            <Spinner v-if="productPageStore.isRetrievingShippingOptions" size="sm" />
        </div>

        <div class="mt-2 divide-y divide-gray-300/40">
            <ProductShippingOption
                v-for="shippingOption in shippingOptions"
                :key="`shipping_option_${shippingOption.identifier}`"
                :shipping-option="shippingOption"
            />

            <ProductPickupOption
                v-if="productPageStore.shipping?.pickup_enabled && normalShippingOption"
                :readable-date="_.upperFirst(normalShippingOption.readable_date)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import Spinner from '@/components/spinners/Spinner.vue';
import ProductPickupOption from '@/pages/product-page/partials/product-info/partials/ProductPickupOption.vue';
import ProductShippingOption from '@/pages/product-page/partials/product-info/partials/ProductShippingOption.vue';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { MagentoPaazlShippingOptionObject, PaazlShippingOptionIdentifierEnum } from '@/types/generated';
import _ from 'lodash';
import { computed } from 'vue';

const productPageStore = useProductPageStore();
const shippingOptions = computed(() => productPageStore.shipping?.shipping_options);
const hasShippingOptions = computed(() => shippingOptions.value && shippingOptions.value.length > 0);
const normalShippingOption = computed(() =>
    shippingOptions.value?.find(
        (option: MagentoPaazlShippingOptionObject) => option.identifier === PaazlShippingOptionIdentifierEnum.SHIPPING_NORMAL,
    ),
);
</script>
